import React from 'react'
import styles from './index.module.scss'
import InvestorLoginC from '../../../stories/investor/investor-login'

export default function InvestorLogin() {
  return (
    <div className={styles.loginBg}>
        <InvestorLoginC/>
    </div>
  )
}
